import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Blog1 from "../src/Pages/Blog1";
import Blog2 from "../src/Pages/Blog2";
import Blog3 from "../src/Pages/Blog3";
import Blog4 from "../src/Pages/Blog4";

// --- Components ---

function Navbar() {
  return (
    <nav style={styles.navbar}>
      <h1 style={styles.logo}>Dox Scanner</h1>
      <div>
        <Link to="/" style={styles.link}>Home</Link>
        <Link to="/privacy" style={styles.link}>Privacy</Link>
        <Link to="/support" style={styles.link}>Support</Link>
      </div>
    </nav>
  );
}

function Landing() {
  return (
    <div>
      {/* Hero Section */}
   <section style={styles.hero}>
  <h2 style={styles.heroTitle}>
    All-in-One PDF Scanner & Editor
  </h2>

  <p style={styles.heroText}>
    The most private way to scan, edit, and manage PDFs.
    100% offline, secure, and professional — no accounts,
    no cloud uploads, and no tracking.
  </p>

  <div style={styles.storeButtons}>
    {/* App Store Button */}
    <a
      href="https://apps.apple.com/app/id6761522255"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      <button
        style={{
          ...styles.storeButton,
          background: "#fff",
          color: "#000",
        }}
      >
        <div>
          <div style={styles.smallText}>Download on the</div>
          <div style={styles.bigText}>App Store</div>
        </div>
      </button>
    </a>

    {/* Play Store Button */}
    <a
      href="https://play.google.com/store/apps/details?id=com.doxscanner&pcampaignid=web_share"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      <button
        style={{
          ...styles.storeButton,
          background:
            "linear-gradient(135deg, #34A853, #0F9D58)",
          color: "#fff",
        }}
      >
        <div>
          <div style={styles.smallText}>Get it on</div>
          <div style={styles.bigText}>Google Play</div>
        </div>
      </button>
    </a>
  </div>
</section>

      {/* Features Grid */}
      <section style={styles.section}>
        <h2 style={styles.title}>Powerful Offline Features</h2>
        <div style={styles.grid}>
          <div style={styles.card}>📄 Scan & Manage PDFs</div>
          <div style={styles.card}>✏️ Edit PDFs</div>
          <div style={styles.card}>🧠 OCR Text Recognition</div>
          <div style={styles.card}>🎤 Voice to PDF</div>
          <div style={styles.card}>🔀 Merge & Split PDFs</div>
          <div style={styles.card}>🔒 Password Protection</div>
          <div style={styles.card}>🖼️ Image to PDF</div>
          <div style={styles.card}>📑 Rearrange Pages</div>
        </div>
      </section>

      {/* App Screenshots */}
      <section style={styles.section}>
        <h2 style={styles.title}>App Screenshots</h2>
        <div style={styles.grid}>
          <img src="/screenshot1.png" alt="Scan Screen" style={styles.image} />
          <img src="/screenshot2.png" alt="Edit Screen" style={styles.image} />
          <img src="/screenshot3.png" alt="OCR Screen" style={styles.image} />
          <img src="/screenshot4.png" alt="Merge Screen" style={styles.image} />
          <img src="/screenshot5.png" alt="Security Screen" style={styles.image} />
          <img src="/screenshot6.png" alt="Export Screen" style={styles.image} />
        </div>
      </section>

      {/* Why Choose Section */}
      <section style={{ ...styles.section, background: "#f9f9f9" }}>
        <h2 style={styles.title}>Why Choose Dox Scanner</h2>
        <p style={styles.text}>
          Fast, secure, and packed with powerful features. Everything you need to work with PDFs in one simple app that respects your data.
        </p>
        <div style={styles.grid}>
          <div style={styles.card}>
            ⭐ 4.8/5 Rating
            <p style={styles.text}>High-quality on-device processing.</p>
          </div>
          <div style={styles.card}>
            👥 Built for Pros
            <p style={styles.text}>Trusted by students and professionals.</p>
          </div>
          <div style={styles.card}>
            📊 100% Private
            <p style={styles.text}>Optimized performance without data collection.</p>
          </div>
        </div>
      </section>

      <section style={styles.section}>
  <h2 style={styles.title}>Latest Articles</h2>

  <div style={styles.grid}>
    <Link
      to="/blog/best-pdf-scanner-app-android"
      style={styles.link}
    >
      Best PDF Scanner App for Android
    </Link>

    <Link
      to="/blog/scan-documents-to-pdf-iphone"
      style={styles.link}
    >
      Scan Documents to PDF Offline
    </Link>

    <Link
      to="/blog/offline-pdf-scanner-privacy"
      style={styles.link}
    >
      Why Offline Scanner Apps Are Better
    </Link>
     <Link
      to="/blog/offline-pdf-scanner-privacy2"
      style={styles.link}
    >
      Best Free PDF Scanner, PDF Merge, and Image to PDF Tools for Daily Use
    </Link>
  </div>
</section>

      {/* Final CTA */}
      <section style={styles.section}>
        <h2 style={styles.title}>Start Managing PDFs Smarter</h2>
        <p style={styles.text}>Join users improving productivity with Dox Scanner.</p>
        <a href="https://apps.apple.com/app/id6761522255" target="_blank" rel="noopener noreferrer">
          <button style={{...styles.button, padding: "15px 40px", fontSize: "18px"}}>
            Get it for iOS
          </button>
        </a>
      </section>
      
    </div>
  );
}

function Privacy() {
  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Privacy Policy</h2>

      <p style={styles.text}>
        <b>Effective Date:</b> April 4, 2026
      </p>

      <p style={styles.text}>
        Dox Scanner is built with a <b>privacy-first</b> approach. Your documents and data remain fully under your control.
      </p>

      <h3 style={styles.subtitle}>Information We Do Not Collect</h3>
      <p style={styles.text}>
        Dox Scanner does <b>not collect, store, or transmit</b> any personal data, documents, images, or biometric information.
        We do not use analytics, advertising SDKs, or third-party tracking services.
      </p>

      <h3 style={styles.subtitle}>Camera Permission Usage</h3>
      <p style={styles.text}>
        The app requests <b>camera permission (android.permission.CAMERA)</b> only for:
        scanning documents, capturing images, and performing OCR (text recognition).
        All processing happens <b>locally on your device</b> and is never uploaded to any server.
      </p>

      <h3 style={styles.subtitle}>On-Device Processing</h3>
      <p style={styles.text}>
        All features including OCR, image processing, PDF creation, and editing are executed entirely on-device without internet dependency.
      </p>

      <h3 style={styles.subtitle}>Data Storage</h3>
      <p style={styles.text}>
        All files are stored locally on your device. If you uninstall the app, all locally stored data is removed unless saved externally by you.
      </p>

      <h3 style={styles.subtitle}>Third-Party Services</h3>
      <p style={styles.text}>
        Dox Scanner does not use any third-party analytics, advertising, or data collection SDKs.
      </p>

      <h3 style={styles.subtitle}>Contact</h3>
      <p style={styles.text}>
        Questions? Email us at: <b>DoxScanner01@gmail.com</b>
      </p>
    </div>
  );
}

function Support() {
  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Support</h2>
      <p style={styles.text}>Need help? Contact us anytime for technical support or feedback.</p>
      <p style={styles.text}><b>Email:</b> DoxScanner01@gmail.com</p>

      <div style={{marginTop: "20px"}}>
        <input placeholder="Your Email" style={styles.input} />
        <textarea placeholder="Tell us what's happening..." style={styles.textarea} />
        <button style={styles.button}>Submit Ticket</button>
      </div>
    </div>
  );
}

// --- App Root ---

export default function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/blog/best-pdf-scanner-app-android" element={<Blog1 />} />
        <Route path="/blog/scan-documents-to-pdf-iphone" element={<Blog2 />} />
        <Route path="/blog/offline-pdf-scanner-privacy" element={<Blog3 />} />
        <Route path="/blog/offline-pdf-scanner-privacy2" element={<Blog4 />} />

      </Routes>
      <Analytics />
      <footer style={styles.footer}>© 2026 Dox Scanner — Bharat Yadav</footer>
    </Router>
  );
}

// --- Styles ---

const styles = {
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 40px",
    background: "#fff",
    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  },
  logo: { fontSize: "22px", fontWeight: "bold", margin: 0 },
  link: {
    margin: "0 15px",
    textDecoration: "none",
    color: "#333",
    fontWeight: "500",
  },
  hero: {
    height: "70vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "#000",
    textAlign: "center",
    padding: "0 20px",
  },
  heroTitle: {
    fontSize: "42px",
    fontWeight: "bold",
    color: "white",
    marginBottom: "15px",
  },
  heroText: {
    fontSize: "18px",
    lineHeight: "1.6",
    maxWidth: "600px",
    color: "#ccc",
    marginBottom: "30px",
  },
  button: {
    padding: "12px 28px",
    background: "blue",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    transition: "0.2s",
  },
  section: {
    padding: "80px 20px",
    textAlign: "center",
  },
  title: {
    fontSize: "32px",
    marginBottom: "30px",
    fontWeight: "bold",
  },
  grid: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    flexWrap: "wrap",
    maxWidth: "1000px",
    margin: "0 auto",
  },
  card: {
    padding: "25px",
    background: "white",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
    borderRadius: "12px",
    width: "220px",
    textAlign: "center",
    fontSize: "16px",
  },
  page: {
    padding: "60px 20px",
    textAlign: "center",
    minHeight: "80vh",
  },
  text: {
    maxWidth: "700px",
    margin: "15px auto",
    lineHeight: "1.6",
    color: "#444",
  },
  input: {
    display: "block",
    margin: "10px auto",
    padding: "12px",
    width: "100%",
    maxWidth: "350px",
    borderRadius: "6px",
    border: "1px solid #ddd",
  },
  textarea: {
    display: "block",
    margin: "10px auto",
    padding: "12px",
    width: "100%",
    maxWidth: "350px",
    height: "120px",
    borderRadius: "6px",
    border: "1px solid #ddd",
  },
  footer: {
    textAlign: "center",
    padding: "30px",
    background: "#111",
    color: "#888",
    fontSize: "14px",
  },
  subtitle: {
    fontSize: "20px",
    fontWeight: "bold",
    marginTop: "30px",
    color: "#111",
  },
  image: {
    width: "260px",
    borderRadius: "15px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
    transition: "transform 0.3s ease",
  },
  storeButtons: {
  display: "flex",
  gap: "18px",
  marginTop: "25px",
  flexWrap: "wrap",
  justifyContent: "center",
},

storeButton: {
  border: "none",
  borderRadius: "16px",
  padding: "16px 28px",
  minWidth: "220px",
  cursor: "pointer",
  transition: "all 0.3s ease",
  boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
},

smallText: {
  fontSize: "13px",
  opacity: 0.9,
  marginBottom: "2px",
},

bigText: {
  fontSize: "22px",
  fontWeight: "bold",
},
};
